<!-- Edition -->
@if (_mode === 'edition') {
  <div>
    <div class="row">
      <div class="col-sm-12">
        <fieldset class="form-group">
          <label for="directeur_titre">Titre</label>
        <input class="form-control" name="directeur_titre" id="directeur_titre" type="text" [(ngModel)]="_directeur.titre" (ngModelChange)="emitDirecteur($event)" /> </fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <fieldset class="form-group">
          <label for="directeurCivilite">Civilité : </label>
          <mat-select class="form-control" name="directeurCivilite" id="directeurCivilite" [compareWith]="compareByValue" [(ngModel)]="_directeur.civilite" (ngModelChange)="emitDirecteur($event)" required>
            <mat-option value="f">Madame</mat-option>
            <mat-option value="m">Monsieur</mat-option>
          </mat-select>
        </fieldset>
      </div>
      <div class="col-sm-4">
        <fieldset class="form-group">
          <label for="directeur_nom">Nom</label>
        <input class="form-control" name="directeur_nom" id="directeur_nom" type="text" [(ngModel)]="_directeur.nom" (ngModelChange)="emitDirecteur($event)" /> </fieldset>
      </div>
      <div class="col-sm-4">
        <fieldset class="form-group">
          <label for="directeur_prenom">Prénom</label>
        <input class="form-control" name="directeur_prenom" id="directeur_prenom" type="text" [(ngModel)]="_directeur.prenom" (ngModelChange)="emitDirecteur($event)" /> </fieldset>
      </div>
    </div>
  </div>
}
<!-- visualisation -->
@if (_mode === 'visualisation') {
  <div>
    <div class="row">
      <div class="col-sm-3">Titre : {{_directeur.titre}}</div>
      <div class="col-sm-3">Civilité :  @if (_directeur.civilite === 'f') {
        <span>Madame</span>
        }@if (_directeur.civilite === 'm') {
        <span>Monsieur</span>
      }</div>
      <div class="col-sm-3">Nom : {{_directeur.nom}}</div>
      <div class="col-sm-3">Prénom : {{_directeur.prenom}}</div>
    </div>
  </div>
}